import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import BaseInfo from './baseInfo/index.vue';
import Logs from './logs/index.vue';
import { loading } from '@/decorators';

var Transit = function (_super) {
  __extends(Transit, _super);

  function Transit() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loading = false;
    _this.detailData = {};
    return _this;
  }

  Transit.prototype.queryDetail = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.queryProductFreezeDetails(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.detailData = res.data;
            }

            return [2];
        }
      });
    });
  };

  Transit.prototype.created = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryDetail({
              id: this.$route.query.id
            })];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  __decorate([loading('loading')], Transit.prototype, "queryDetail", null);

  Transit = __decorate([Component({
    components: {
      BaseInfo: BaseInfo,
      Logs: Logs
    }
  })], Transit);
  return Transit;
}(Vue);

export default Transit;